import { MsalProvider } from '@azure/msal-react';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { ConnectedRouter } from 'connected-react-router';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import { history, store } from '@redux/store';
import { msalClient } from '@utils';

import { App } from './App';
import { appInsightsPlugin } from './AppInsights';

import './common/styles/main.scss';
import './common/styles/themes.scss';

import 'bootstrap/dist/css/bootstrap.css';
//eslint-disable-next-line import/no-unresolved
import 'swiper/css';

const root = document.getElementById('root');

function isTouchDevice() {
  console.log(('ontouchstart' in window) ||
  (navigator.maxTouchPoints > 0));
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0));
}

const options = { enableMouseEvents: true };

render(
  <Provider store={store}>
    <MsalProvider instance={msalClient}>
      <ConnectedRouter history={history}>
        <AppInsightsContext.Provider value={appInsightsPlugin}>
          {isTouchDevice() ? (
            <DndProvider backend={TouchBackend} options={options}>
              <App />
            </DndProvider>
          ) : (
            <DndProvider backend={HTML5Backend}>
              <App />
            </DndProvider>
          )}
        </AppInsightsContext.Provider>
      </ConnectedRouter>
    </MsalProvider>
  </Provider>,
  root
);
